module.exports = __webpack_public_path__ + "static/media/Vazirmatn-Regular.cdc14062.woff2";